import { useFieldArray, useFormContext } from 'react-hook-form';
import { DeleteOutlined, PlusOutlined } from '@ant-design/icons';
import { Button, Table, TableColumnsType } from 'antd';

import { InputForm } from '@/components/form/Input';
import { InputNumberForm } from '@/components/form/InputNumber';

export const LocalExhaustsTable: React.FC = () => {
  const { control, reset, setValue, getValues, watch, resetField } =
    useFormContext();

  const { fields, remove, insert } = useFieldArray({
    control,
    name: 'mo_table',
  });

  const handleAddRow = (index: number) => {
    const nullValuesObject: Record<string, null> = {
      count: null,
      flow_mo_inflow: null,
      flow_mo_exhaust: null,
      flow_inflow: null,
      flow_exhaust: null,
      sys_mo_inflow: null,
      sys_mo_exhaust: null,
    };

    insert(index + 1, {
      ...nullValuesObject,
      i: fields.length + 1,
    });
  };

  const handleRemoveRow = (index: number) => {
    remove(index);
  };

  const get_flow = (index: number) => {
    const count = watch(`mo_table[${index}].count`);
    const flow_mo_inflow = watch(`mo_table[${index}].flow_mo_inflow`);
    const flow_mo_exhaust = watch(`mo_table[${index}].flow_mo_exhaust`);
    if (flow_mo_inflow && count) {
      setValue(`mo_table[${index}].flow_inflow`, count * flow_mo_inflow);
    } else {
      setValue(`mo_table[${index}].flow_inflow`, null);
    }

    if (flow_mo_exhaust && count) {
      setValue(`mo_table[${index}].flow_exhaust`, count * flow_mo_exhaust);
    } else {
      setValue(`mo_table[${index}].flow_exhaust`, null);
    }
  };

  const columns: TableColumnsType<any> = [
    {
      title: 'Кол-во единиц оборудования, шт',
      dataIndex: 'count',
      align: 'center',
      className: 'min-w-[140px]',
      render: (text, record, index) => (
        <InputNumberForm size='middle' name={`mo_table[${index}].count`} />
      ),
    },

    {
      title: 'Расход воздуха на единицу М.О.',
      className: 'text-nowrap min-w-[280px]',
      children: [
        {
          title: 'Приток, м3/ч',
          dataIndex: 'flow_mo_inflow',
          width: 140,
          align: 'center',
          render: (text, record, index) => (
            <InputNumberForm
              size='middle'
              name={`mo_table[${index}].flow_mo_inflow`}
            />
          ),
        },
        {
          title: 'Вытяжка, м3/ч',
          dataIndex: 'flow_mo_exhaust',
          width: 140,
          align: 'center',
          render: (text, record, index) => (
            <InputNumberForm
              size='middle'
              name={`mo_table[${index}].flow_mo_exhaust`}
            />
          ),
        },
      ],
    },
    {
      title: 'Расход воздуха',
      className: 'min-w-[280px]',
      children: [
        {
          title: 'Приток, м3/ч',
          dataIndex: 'flow_inflow',
          width: 140,
          align: 'center',
          render: (text, record, index) => (
            <InputNumberForm
              disabled
              size='middle'
              name={`mo_table[${index}].flow_inflow`}
            />
          ),
        },
        {
          title: 'Вытяжка, м3/ч',
          dataIndex: 'flow_exhaust',
          width: 140,
          align: 'center',
          render: (text, record, index) => (
            <InputNumberForm
              disabled
              size='middle'
              name={`mo_table[${index}].flow_exhaust`}
            />
          ),
        },
      ],
    },
    {
      title: 'Обозначение системы М.О.',
      className: 'text-nowrap min-w-[280px]',
      children: [
        {
          title: 'Приток',
          dataIndex: 'sys_mo_inflow',
          width: 140,
          align: 'center',
          render: (text, record, index) => (
            <InputForm name={`mo_table[${index}].sys_mo_inflow`} />
          ),
        },
        {
          title: 'Вытяжка',
          dataIndex: 'sys_mo_exhaust',
          width: 140,
          align: 'center',
          render: (text, record, index) => (
            <InputForm name={`mo_table[${index}].sys_mo_exhaust`} />
          ),
        },
      ],
    },
    {
      title: '',
      dataIndex: '',
      render: (text, record, index) => {
        return (
          <div className='flex gap-2'>
            <Button
              icon={<PlusOutlined />}
              onClick={() => handleAddRow(index)}
            />
            <Button
              disabled={fields?.length === 1}
              icon={<DeleteOutlined />}
              onClick={() => handleRemoveRow(index)}
            />
          </div>
        );
      },
    },
  ];

  return (
    <div className='overflow-auto'>
      <Table
        size='small'
        rowKey={(record) => record?.id}
        columns={columns}
        dataSource={fields}
        pagination={false}
        onRow={(record, rowIndex: any) => {
          return {
            onKeyUp: () => get_flow(rowIndex),
          };
        }}
      />
    </div>
  );
};
